import React from 'react';
import type { Icon } from '@phosphor-icons/react';

/**
 * iOS-Schalter (README §4.8): Track 52×32 (klein 40×24), Knopf weiß 26/20 px,
 * Hintergrund-Übergang .25 s. An = --ok, aus = --fill3.
 */
export interface IosSwitchProps {
  an: boolean;
  onChange: (an: boolean) => void;
  klein?: boolean;
  label?: string;
  disabled?: boolean;
}

export function IosSwitch({ an, onChange, klein = false, label, disabled }: IosSwitchProps) {
  const w = klein ? 40 : 52;
  const h = klein ? 24 : 32;
  const k = klein ? 20 : 26;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={an}
      aria-label={label}
      disabled={disabled}
      onClick={e => { e.stopPropagation(); onChange(!an); }}
      className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
      style={{
        width: w, height: h, borderRadius: h / 2, padding: klein ? 2 : 3, border: 'none', flexShrink: 0,
        display: 'flex', justifyContent: an ? 'flex-end' : 'flex-start',
        background: an ? 'var(--ok)' : 'var(--fill3)', transition: 'background .25s', opacity: disabled ? 0.45 : 1,
      }}
    >
      <span style={{ width: k, height: k, borderRadius: '50%', background: '#fff', boxShadow: klein ? '0 1px 4px rgba(0,0,0,0.25)' : '0 2px 6px rgba(0,0,0,0.25)' }} />
    </button>
  );
}

/** Ganze Zeile klickbar: Icon + Text links, Schalter rechts (Formulare, Berechtigungen). */
export function SchalterZeile({ an, onChange, label, icon: IconKomp, klein = false, hintergrundAn, disabled = false, zusatz }: IosSwitchProps & {
  label: string;
  icon?: Icon;
  /** Zeilen-Hintergrund, wenn an (z. B. --ok-soft bei „Bereits bezahlt“). */
  hintergrundAn?: string;
  /** Kleine Zeile unter dem Label, z. B. „Wird noch angebunden“. */
  zusatz?: string;
}) {
  return (
    <div
      onClick={disabled ? undefined : () => onChange(!an)}
      className={`flex items-center justify-between ${disabled ? '' : 'cursor-pointer'}`}
      style={{
        gap: 12, padding: klein ? '7px 6px 7px 8px' : '12px 14px 12px 16px', borderRadius: klein ? 11 : 16,
        background: an && hintergrundAn ? hintergrundAn : klein ? 'transparent' : 'var(--bg)',
        boxShadow: klein ? 'none' : 'inset 0 0 0 1px var(--line)', transition: 'background .3s',
      }}
    >
      <span className="flex items-center min-w-0" style={{ gap: 10, fontSize: klein ? 13 : 14, fontWeight: klein ? 600 : 700, opacity: disabled ? 0.6 : 1 }}>
        {IconKomp && <IconKomp weight="fill" size={19} color="var(--acc)" style={{ flexShrink: 0 }} />}
        <span className="flex flex-col min-w-0">
          {label}
          {zusatz && <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink3)' }}>{zusatz}</span>}
        </span>
      </span>
      <IosSwitch an={an} onChange={onChange} klein={klein} label={label} disabled={disabled} />
    </div>
  );
}
